import { NumberInput } from '@mantine/core';

export interface NumberFilterProps {
  description?: string;
  placeholder?: string;

  isDisabled?: boolean;

  label: string;

  min?: number;
  max?: number;
  allowDecimal: boolean;

  value: number | string | undefined;
  onChange: (v: string | number) => void;

  flex?: number;
}

export function NumberFilter(props: NumberFilterProps) {
  const { label, placeholder, description, isDisabled, value, onChange, min, max, allowDecimal, flex } = props;

  return (
    <NumberInput
      value={value}
      onChange={onChange}
      label={label}
      description={description}
      placeholder={placeholder ?? label}
      disabled={isDisabled}
      min={min ?? 0}
      max={max}
      allowDecimal={allowDecimal}
      fixedDecimalScale={allowDecimal}
      decimalScale={allowDecimal ? 2 : undefined}
      flex={flex ?? 1}
    />
  );
}
